import { useState, useEffect,useCallback } from "react";
import { useSelector, useDispatch  } from "react-redux";
import {
  addBillreview,
  getBillreviews,
  getBillreview,
  editBillreview,
  deleteBillreview,
  getAllBillreviews,
} from "../../store/actions/billreview_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllBillreviews = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.billreview);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
 
  useEffect(() => {
    if (deleteEntry) {
      dispatch(deleteBillreview(deleteEntry));
  }
    allQuery();
  }, [deleteEntry, pageNumber, window.location.search]);
  const allQuery = useCallback(
    _debounce(() => {
     
      dispatch(
        getBillreviews({
          pageNumber,
        })
      );
    }, 1000),
    []
  );

  useEffect(() => {
    setPageNumber(1);
  }, [window.location.search]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };

  return [
    data, setPageNumber, deleteBtnClicked
  ];
};

// Get Single Data
export const useSingleBillreview = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.billreview);
  useEffect(() => {
    dispatch(getBillreview(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateBillreview = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.billreview);
  const addData = async (data) => {
    await dispatch(addBillreview(data));
  };
  return [data, addData];
};
export const useUpdateBillreview = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.billreview);
  const updateData = async (id, data) => {
    await dispatch(editBillreview(id, data));
  };
  return [updateData];
};

export const useSelectAllBillreview = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.billreview);
  useEffect(() => {
    dispatch(getAllBillreviews({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};


export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
    // useSelectAllClient();
 
  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

 
  return [dropdownOptions
    // setClientSearchField, setClientSearchValue
  ];
};